export default __webpack_public_path__ + "media/images/open_tab_black-d25b825c8de10c359dc721a04323eba4.png";